<template>
  <v-app class="admin-app">
    <v-main>
      <router-view></router-view>
    </v-main>
  </v-app>
</template>

<script>
import RegisterStoreModule from '@/mixins/RegisterStoreModule';
import globalStore from '@/store.js';
import employeeState from '@/modules/Employee/store';

export default {
  name: 'App',
  mixins: [RegisterStoreModule],
  async created() {
    await this.registerStoreModule('global', globalStore);
    await this.registerStoreModule('employee', employeeState)
    console.log('register is done')
  },
};

</script>

<style lang="scss">
@import '@/scss/variable.scss';
@import '@/scss/app.scss';

.admin-app {
  background: var(--v-background-base) !important;
  color: var(--v-theme-text, inherit);
  transition: background-color 180ms ease, color 180ms ease;
}

.theme--dark.admin-app {
  --v-theme-text: #e5edf8;
  background-image:
    linear-gradient(rgba(96, 165, 250, 0.025) 1px, transparent 1px),
    linear-gradient(90deg, rgba(96, 165, 250, 0.025) 1px, transparent 1px),
    radial-gradient(circle at 82% 5%, rgba(37, 99, 235, 0.14), transparent 30rem) !important;
  background-size: 64px 64px, 64px 64px, auto !important;
}

.theme--light.admin-app {
  --v-theme-text: #172033;
  background-image:
    linear-gradient(rgba(45, 76, 115, 0.018) 1px, transparent 1px),
    linear-gradient(90deg, rgba(45, 76, 115, 0.018) 1px, transparent 1px),
    radial-gradient(circle at 82% 5%, rgba(37, 99, 235, 0.075), transparent 28rem) !important;
  background-size: 64px 64px, 64px 64px, auto !important;
}
</style>
